import { Button, Card, CardBody, Typography } from "@material-tailwind/react";

import { useState } from "react";
import IconBackground from "../../../components/common/IconBackground";
import { GoArrowDownLeft, GoArrowUpRight } from "react-icons/go";
import { formatDate } from "../../../utility";
import DefaultLoading from "../../../components/common/DefaultLoading";
import ErrorLoadingState from "../../../components/common/buttons/ErrorLoadingState";
import { Link } from "react-router-dom";
import { routerPaths } from "../../../services/path";
import useTransactionApi from "../../../hooks/useTransactionApi";
import EmptyState from "../../../components/common/EmptyState";

function TransactionsCard() {
  const [activeTab, setActiveTab] = useState("All");
  const tabs = ["All", "Income", "WithDraw"];

  const { data, isLoading: isLoadingTransaction, error } = useTransactionApi();

  const transactionData = data?.data.data;

  if (isLoadingTransaction) {
    return <DefaultLoading />;
  }

  if (error) {
    return (
      <div>
        <ErrorLoadingState />
      </div>
    );
  }

  if (transactionData?.length === 0) {
    return (
      <Card placeholder={undefined} className="flex justify-center shadow-sm">
        <CardBody
          placeholder={undefined}
          className="justify-center items-center"
        >
          <div className="justify-center flex ">
            <EmptyState />
          </div>
          <Typography placeholder={undefined} className="text-center">
            No Transactions yet
          </Typography>
        </CardBody>
      </Card>
    );
  }

  return (
    <div>
      <Card placeholder={undefined} className="shadow-sm">
        <CardBody placeholder={undefined}>
          <div className="flex justify-between items-center">
            <Typography placeholder={undefined}>Transactions</Typography>
            <Link to={routerPaths.transaction}>
              <Typography placeholder={undefined}>View All</Typography>
            </Link>
          </div>
          <div className="flex ">
            {tabs.map((tab) => (
              <Button
                placeholder={undefined}
                key={tab}
                onClick={() => setActiveTab(tab)}
                className={`m-1 p-3 text-normal text-sm font-medium normal-case mb-6
                ${tab === activeTab ? "text-white" : "text-white bg-gray-500"}
                `}
              >
                {tab}
              </Button>
            ))}
          </div>
          {/* <Typography className="mt-4 mb-2">Today</Typography> */}

          {transactionData!
            .slice(0, 10)
            .filter((transaction) => {
              if (activeTab === "All") {
                return true;
              } else if (activeTab === "Income") {
                return transaction.transType === "CR";
              } else if (activeTab === "WithDraw") {
                return transaction.transType !== "CR";
              }
              return false;
            })
            .map((transaction) => (
              <div
                key={transaction.paymentReference}
                className="flex justify-between items-center mb-2"
              >
                <div className="flex items-center">
                  <IconBackground
                    icon={
                      transaction.transType === "CR" ? (
                        <GoArrowUpRight color={"white"} size={20} />
                      ) : (
                        <GoArrowDownLeft color={"white"} size={20} />
                      )
                    }
                    backgroundColor="bg-black"
                  />
                  <div className="ml-3">
                    <Typography
                      placeholder={undefined}
                      className="text-sm font-medium"
                    >
                      {transaction.transactionDesc === ""
                        ? "Boat Transaction"
                        : transaction.transactionDesc}
                    </Typography>
                    <Typography placeholder={undefined} className="text-xs">
                      {formatDate(transaction.createdOn)}
                    </Typography>
                  </div>
                </div>

                <Typography
                  placeholder={undefined}
                  className={`${
                    transaction.transType === "CR"
                      ? "text-green-500"
                      : "text-red-500"
                  }
                font-bold text-sm
                `}
                >
                  {transaction.transType === "CR" ? "+" : "-"}
                  {transaction.amount}
                </Typography>
              </div>
            ))}
        </CardBody>
      </Card>
    </div>
  );
}

export default TransactionsCard;
